var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "main" },
    [
      _c(
        "drag-dialog",
        _vm._g(
          _vm._b(
            {
              staticClass: "gl-new-dialogPop ",
              attrs: { title: "User Guide Detl", isShowFollow: false },
              on: { open: _vm.opened, close: _vm.closed },
            },
            "drag-dialog",
            _vm.$attrs,
            false
          ),
          _vm.$listeners
        ),
        [
          _c("div", { staticClass: "panel-body" }, [
            _c(
              "div",
              { staticClass: "content" },
              [
                _c(
                  "el-form",
                  {
                    ref: "form",
                    attrs: {
                      rules: _vm.rules,
                      model: _vm.form,
                      disabled: _vm.disabledType,
                    },
                  },
                  [
                    _c("div", { staticClass: "item" }, [
                      _c(
                        "div",
                        {
                          staticClass: "item-box-title",
                          staticStyle: { margin: "0px" },
                        },
                        [
                          _c(
                            "div",
                            {
                              staticClass: "h-opt",
                              staticStyle: { float: "right", padding: "0px" },
                            },
                            [
                              !_vm.disabledType
                                ? _c(
                                    "el-button",
                                    {
                                      staticClass: "btn-plain-primary-new",
                                      attrs: {
                                        plain: "",
                                        type: "default",
                                        icon: "el-icon-circle-check",
                                        size: "mini",
                                      },
                                      on: { click: _vm.handleSave },
                                    },
                                    [
                                      _vm._v(
                                        "\n                  " +
                                          _vm._s(_vm.$t("common.btn.save")) +
                                          "\n                "
                                      ),
                                    ]
                                  )
                                : _vm._e(),
                              _vm._v(" "),
                              !_vm.disabledType
                                ? _c(
                                    "el-button",
                                    {
                                      staticClass: "btn-plain-primary-new",
                                      attrs: {
                                        plain: "",
                                        type: "default",
                                        icon: "el-icon-refresh-left",
                                        size: "mini",
                                      },
                                      on: { click: _vm.handleCancel },
                                    },
                                    [
                                      _vm._v(
                                        "\n                  " +
                                          _vm._s(_vm.$t("common.btn.cancel")) +
                                          "\n                "
                                      ),
                                    ]
                                  )
                                : _vm._e(),
                            ],
                            1
                          ),
                        ]
                      ),
                      _vm._v(" "),
                      _c("div", { staticClass: "item-content" }, [
                        _c(
                          "table",
                          {
                            staticClass: "mailTable",
                            staticStyle: {
                              width: "100%",
                              "margin-bottom": "0",
                            },
                          },
                          [
                            _c("colgroup", [
                              _c("col", { attrs: { width: "100px" } }),
                              _vm._v(" "),
                              _c("col", { attrs: { width: "100px" } }),
                              _vm._v(" "),
                              _c("col", { attrs: { width: "100px" } }),
                              _vm._v(" "),
                              _c("col", { attrs: { width: "100px" } }),
                              _vm._v(" "),
                              _c("col", { attrs: { width: "100px" } }),
                              _vm._v(" "),
                              _c("col", { attrs: { width: "100px" } }),
                              _vm._v(" "),
                              _c("col", { attrs: { width: "100px" } }),
                              _vm._v(" "),
                              _c("col", { attrs: { width: "100px" } }),
                            ]),
                            _vm._v(" "),
                            _c("tr", [
                              _c(
                                "td",
                                {
                                  staticClass: "column is-required",
                                  attrs: { colspan: "2" },
                                },
                                [
                                  _c("span", { staticClass: "column-after" }, [
                                    _vm._v(_vm._s(_vm.$t("pool.model"))),
                                  ]),
                                  _vm._v(" "),
                                  _c(
                                    "el-form-item",
                                    { attrs: { prop: "model" } },
                                    [
                                      _c("el-input", {
                                        attrs: {
                                          placeholder: _vm.$t(
                                            "contract.placeholder"
                                          ),
                                          maxlength: "200",
                                        },
                                        model: {
                                          value: _vm.form.model,
                                          callback: function ($$v) {
                                            _vm.$set(
                                              _vm.form,
                                              "model",
                                              typeof $$v === "string"
                                                ? $$v.trim()
                                                : $$v
                                            )
                                          },
                                          expression: "form.model",
                                        },
                                      }),
                                    ],
                                    1
                                  ),
                                ],
                                1
                              ),
                              _vm._v(" "),
                              _c(
                                "td",
                                {
                                  staticClass: "column is-required",
                                  attrs: { colspan: "2" },
                                },
                                [
                                  _c("span", { staticClass: "column-after" }, [
                                    _vm._v(_vm._s(_vm.$t("pool.item"))),
                                  ]),
                                  _vm._v(" "),
                                  _c(
                                    "el-form-item",
                                    { attrs: { prop: "item" } },
                                    [
                                      _c("el-input", {
                                        attrs: {
                                          placeholder: _vm.$t(
                                            "contract.placeholder"
                                          ),
                                          maxlength: "200",
                                        },
                                        model: {
                                          value: _vm.form.item,
                                          callback: function ($$v) {
                                            _vm.$set(
                                              _vm.form,
                                              "item",
                                              typeof $$v === "string"
                                                ? $$v.trim()
                                                : $$v
                                            )
                                          },
                                          expression: "form.item",
                                        },
                                      }),
                                    ],
                                    1
                                  ),
                                ],
                                1
                              ),
                              _vm._v(" "),
                              _c(
                                "td",
                                {
                                  staticClass: "column",
                                  attrs: { colspan: "2" },
                                },
                                [
                                  _c("span", { staticClass: "column-after" }, [
                                    _vm._v(_vm._s(_vm.$t("pool.sequence"))),
                                  ]),
                                  _vm._v(" "),
                                  _c(
                                    "el-form-item",
                                    { attrs: { prop: "sequence" } },
                                    [
                                      _c("el-input-number", {
                                        staticClass: "left-aligned-input",
                                        attrs: {
                                          precision: 0,
                                          "auto-cut": true,
                                          min: 0,
                                          controls: false,
                                          max: 99999,
                                        },
                                        model: {
                                          value: _vm.form.sequence,
                                          callback: function ($$v) {
                                            _vm.$set(
                                              _vm.form,
                                              "sequence",
                                              typeof $$v === "string"
                                                ? $$v.trim()
                                                : $$v
                                            )
                                          },
                                          expression: "form.sequence",
                                        },
                                      }),
                                    ],
                                    1
                                  ),
                                ],
                                1
                              ),
                              _vm._v(" "),
                              _c(
                                "td",
                                {
                                  staticClass: "column",
                                  attrs: { colspan: "2" },
                                },
                                [
                                  _c("span", { staticClass: "column-after" }, [
                                    _vm._v(_vm._s(_vm.$t("pool.status"))),
                                  ]),
                                  _vm._v(" "),
                                  _c(
                                    "el-form-item",
                                    { attrs: { prop: "status" } },
                                    [
                                      _c(
                                        "el-select",
                                        {
                                          attrs: { clearable: "" },
                                          model: {
                                            value: _vm.form.status,
                                            callback: function ($$v) {
                                              _vm.$set(_vm.form, "status", $$v)
                                            },
                                            expression: "form.status",
                                          },
                                        },
                                        _vm._l(_vm.statusList, function (item) {
                                          return _c("el-option", {
                                            key: item.codeValue,
                                            attrs: {
                                              label:
                                                _vm.language === "zh"
                                                  ? item.displayValueCn
                                                  : item.displayValue,
                                              value: item.codeValue,
                                              placeholder: _vm.$t(
                                                "contract.placeholder"
                                              ),
                                            },
                                          })
                                        }),
                                        1
                                      ),
                                    ],
                                    1
                                  ),
                                ],
                                1
                              ),
                            ]),
                            _vm._v(" "),
                            _c("tr", [
                              _c(
                                "td",
                                {
                                  staticClass: "column",
                                  attrs: { colspan: "8" },
                                },
                                [
                                  _c("span", { staticClass: "column-after" }, [
                                    _vm._v(_vm._s(_vm.$t("pool.description"))),
                                  ]),
                                  _vm._v(" "),
                                  _c(
                                    "el-form-item",
                                    { attrs: { prop: "description" } },
                                    [
                                      _c("el-input", {
                                        attrs: {
                                          type: "textarea",
                                          autosize: { minRows: 2, maxRows: 5 },
                                          placeholder: _vm.$t(
                                            "contract.placeholder"
                                          ),
                                          maxlength: "500",
                                        },
                                        model: {
                                          value: _vm.form.description,
                                          callback: function ($$v) {
                                            _vm.$set(
                                              _vm.form,
                                              "description",
                                              typeof $$v === "string"
                                                ? $$v.trim()
                                                : $$v
                                            )
                                          },
                                          expression: "form.description",
                                        },
                                      }),
                                    ],
                                    1
                                  ),
                                ],
                                1
                              ),
                            ]),
                            _vm._v(" "),
                            _c("tr", [
                              _c(
                                "td",
                                {
                                  staticClass: "column",
                                  attrs: { colspan: "8" },
                                },
                                [
                                  _c("span", { staticClass: "column-after" }, [
                                    _vm._v(_vm._s(_vm.$t("pool.remark"))),
                                  ]),
                                  _vm._v(" "),
                                  _c(
                                    "el-form-item",
                                    { attrs: { prop: "remark" } },
                                    [
                                      _c("el-input", {
                                        attrs: {
                                          type: "textarea",
                                          autosize: { minRows: 2, maxRows: 5 },
                                          placeholder: _vm.$t(
                                            "contract.placeholder"
                                          ),
                                          maxlength: "500",
                                        },
                                        model: {
                                          value: _vm.form.remark,
                                          callback: function ($$v) {
                                            _vm.$set(
                                              _vm.form,
                                              "remark",
                                              typeof $$v === "string"
                                                ? $$v.trim()
                                                : $$v
                                            )
                                          },
                                          expression: "form.remark",
                                        },
                                      }),
                                    ],
                                    1
                                  ),
                                ],
                                1
                              ),
                            ]),
                          ]
                        ),
                      ]),
                    ]),
                  ]
                ),
              ],
              1
            ),
          ]),
        ]
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }